import React from 'react';
import EventCard from '../../shared/EventCard/EventCard';

const PastEventList = ({ events }) => {
    if (!events || events.length === 0) return null;

    return (
        <div className="agenda-card-list">
            {events.map((ev) => <EventCard key={ev.id} event={ev} href={ev.event_url} />)}
        </div>
    );
};

export default PastEventList;
